'use strict';
import angular from 'angular';
import $ from 'jquery';

import widgetChartHtmlUrl from '../widget.chart.html';

angular.module('widget.serialchart.directives', [])

    .directive('serialchartWidget', serialchartWidget);

/**
 * @ngInject
 */
function serialchartWidget() {
    return {
        restrict: 'E',
        templateUrl: widgetChartHtmlUrl,
        controller: 'SerialChartWidgetController',
        scope: {
            state: '=',
            widget: '<',
            chartId: '<',
            widgetTypeId: '<',
            widgetIsPredefined: '<'
        }
    }
}